import type { VariantProps } from "tailwind-variants";

import { createStyle } from "~/common/utils/create-style";

const buttonStyle = createStyle({
  base: [
    "whitespace-nowrap rounded-l",
    "!text-body-2-emphasis",
    "flex items-center justify-center gap-8",
    "[&_svg]:pointer-events-none [&_svg]:shrink-0",
    "disabled:cursor-not-allowed aria-disabled:cursor-not-allowed",
    "transition-all duration-200",
    "hover:cursor-pointer",
  ],
  variants: {
    preserveAspectRatio: {
      true: "p-8",
      false: "py-8 px-12",
    },
    background: {
      "on-white":
        "disabled:text-text-disabled-on-light disabled:bg-overlay-on-light-20",
      "on-black":
        "disabled:text-text-disabled-on-dark disabled:bg-overlay-on-dark-20",
    },
    variant: {
      primary: "",
      secondary: "",
      ghost: "bg-transparent",
    },
  },
  compoundVariants: [
    // Primary variants
    {
      variant: "primary",
      background: "on-white",
      className: [
        "bg-primary-base-on-light hover:bg-primary-base-hover-on-light focus:bg-primary-base-hover-on-light",
        "text-text-primary-on-dark",
      ],
    },
    {
      variant: "primary",
      background: "on-black",
      className: [
        "bg-primary-base-on-dark hover:bg-primary-base-hover-on-dark focus:bg-primary-base-hover-on-dark",
        "text-text-primary-on-light",
      ],
    },

    // Secondary variants
    {
      variant: "secondary",
      background: "on-white",
      className: [
        "bg-overlay-on-light-20 hover:bg-overlay-on-light-30 focus:bg-overlay-on-light-30",
        "text-text-primary-on-light",
      ],
    },
    {
      variant: "secondary",
      background: "on-black",
      className: [
        "bg-overlay-on-dark-20 hover:bg-overlay-on-dark-30 focus:bg-overlay-on-dark-30",
        "text-text-primary-on-dark",
      ],
    },

    // Ghost variants
    {
      variant: "ghost",
      background: "on-white",
      className: ["text-text-primary-on-light", "hover:bg-overlay-on-light-20"],
    },
    {
      variant: "ghost",
      background: "on-black",
      className: ["text-text-primary-on-dark", "hover:bg-overlay-on-dark-20"],
    },
  ],
  defaultVariants: {
    preserveAspectRatio: false,
    background: "on-black",
    variant: "primary",
  },
});

export type ButtonVariants = VariantProps<typeof buttonStyle>;
export { buttonStyle };
